import { render } from "./WizardProgressBar.vue?vue&type=template&id=6a07223f"
import script from "./WizardProgressBar.vue?vue&type=script&lang=js"
export * from "./WizardProgressBar.vue?vue&type=script&lang=js"

import "./WizardProgressBar.vue?vue&type=style&index=0&id=6a07223f&lang=scss"
script.render = render

export default script